import filter from 'lodash/collection/filter';
import map from 'lodash/collection/map';
import isFunction from 'lodash/lang/isFunction';
import assign from 'lodash/object/assign';
import * as comparatorUtilities from  "../../utility/comparator";
import {
  formatDate,
  formatJoinDate,
  getRebateScriptConfig, getRebateTierIncome,
  isRebateScriptValid,
  rebateScriptMedicareColorOptions,
} from '../../utility/rebate-script';
import { restrictFieldSets } from '../../utility/comparator';


export default ngModule => {

  ngModule.controller('ComparatorStep3Ctrl', function (
    AonApi,
    AonApplicationService,
    AonConfig,
    application,
    fieldsets,
    $log,
    OperatorService,
    $q,
    $sce,
    $scope,
    $state,
    ZohoService,
    zohoStage
    ) {

    const zohoStageIsClosed = zohoStage && zohoStage.is_closed;

    // Track the number of submissions so that we can set a hard limit
    // on how many times we update Zoho
    let submissionCount = 0;

    // Limit on the number of submissions before we bail out
    const maxApplicationSubmissions = 10;

    //
    this.debugTrace = '';
    this.bailedOut = false;

    // Track the application event
    AonApplicationService.trackEvent(
        AonConfig.jsConstants.TrackingEvents.Application,
        AonApplicationService.product.fund.id);

    this.fieldsets = fieldsets;
    this.corporate = $scope.$parent.ctrl.corporate;
    this.application = application;
    this.application.corporate_script_responses = {};
    this.product = AonApplicationService.product.selectedPrice;
    this.package = AonApplicationService.product;
    this.rebate_tier_choices = AonApplicationService.getRebateTierChoices(application);
    let text = AonApplicationService.getRebateTierText(application);
    this.rebate_tier_caption = text.caption;
    this.rebate_tier_description = text.description;
    this.hasPartner = application.hasPartner();

    this.showEndOfApplicationScript = !!this.corporate.end_of_application_script;
    this.fundScript = fieldsets.end_of_application_script;
    this.applicationDisabledStageIsClosed = zohoStageIsClosed;
    this.applicationDisabledPriceNotAvailable = !this.product.is_available_for_purchase;
    this.applicationDisabledFundPublicJoins = !this.corporate.is_operator && this.product.fund.disable_public_joins;
    this.showApplicationForm = !(
        this.applicationDisabledPriceNotAvailable ||
        this.applicationDisabledFundPublicJoins ||
        this.applicationDisabledStageIsClosed
    );

    const updatePricing = () => {
        this.quoted_premium_freq = $scope.$parent.ctrl.paymentFrequencyLabel();
        this.quoted_premium = $scope.$parent.ctrl.currentPrice(AonApplicationService.product);
        this.current_pricing = $scope.$parent.ctrl.currentPricing(AonApplicationService.product);
    };
    updatePricing();

    // Scroll the window depending on operator mode
    if (this.corporate.is_operator) {
      $scope.$parent.ctrl.scrollToId("ui-view");
    } else {
      $scope.$parent.ctrl.scrollToId('step-progress-header', 100);
    }

    // Return early if we are not showing the application form, to prevent any side-effects from running
    // (e.g. updated zoho stage)
    if (!this.showApplicationForm) {
      return;
    }

    // If a Zoho applicant, update the 'Stage' on the opportunity 
    if (application.zoho_id !== undefined) {
      ZohoService.setStage(application.zoho_id, 'application');
    }

    // If the fund chosen in step 1 is not present as an option for the specific fund, force new selection.
    // This does not seem to be happening automatically as it should for angular-driven select list.
    const current_fund = _.get(this.application, 'personal.previous_fund.fund_id');
    const fund_choices = _.get(this.fieldsets, 'personal.previous_fund.fund_id.grouped_choices');
    if (fund_choices && current_fund) {
      let valid_fund = false;
      for(let check_fund of fund_choices) {
        if (check_fund.id == current_fund) {
          valid_fund = true;
          break;
        }
      }
      if (!valid_fund) {
        _.set(this.application, 'personal.previous_fund.fund_id', null);
      }
    }
    
    const lhc_age_validation_message = "Please enter an age between 30 and 110";
    _.set(this.fieldsets, 'dependant.lhc_age_validator', {
      error_messages: {
        min: lhc_age_validation_message,
        max: lhc_age_validation_message,
      }
    });

    /**
     * Configure join and debit date validation
     * Join date minimum is usually current date, unless fund has specified
     * minimum_join_date_relative_to_today != 0, in which case add this number of
     * days to the current date
     * Debit date minimum is usually current date, unless fund has specified
     * minimum_debit_date_relative_to_today != 0, in which case add this number of
     * days to the current date
     */
    const today = new Date();
    this.join_date_minimum = new Date();
    this.join_date_maximum = null;
    this.debit_date_minimum = new Date();

    const join_date_offset = _.get(this.product, 'fund.minimum_join_date_relative_to_today', 0);
    this.join_date_minimum.setDate(this.join_date_minimum.getDate() + join_date_offset);

    const max_join_date_offset = _.get(this.fieldsets, 'payment.maximum_join_date_relative_to_today', null);
    if (max_join_date_offset !== null) {
      this.join_date_maximum = new Date();
      this.join_date_maximum.setDate(this.join_date_maximum.getDate() + max_join_date_offset);
    }
    
    const debit_date_offset_from_today = _.get(this.fieldsets, 'payment.minimum_debit_date_relative_to_today', 0);
    this.debit_date_minimum.setDate(this.debit_date_minimum.getDate() + debit_date_offset_from_today);
    const debit_date_min_value_from_today = this.debit_date_minimum;

    _.set(this.application, 'payment.join_date', this.join_date_minimum);
    _.set(this.application, 'payment.debit_date', this.debit_date_minimum);

    // This fieldset is a mapping of payment_frequency -> maximum_offset_days_relative_to_join_date
    const debit_date_maximum_offset_mapping = _.get(this.fieldsets, 'payment.debit_date_maximum_offset_mapping');
    // This fieldset is a mapping of payment_frequency -> minimum_offset_days_relative_to_debit_date
    const debit_date_minimum_offset_mapping = _.get(this.fieldsets, 'payment.minimum_debit_date_offset_mapping');

    // Fund handler can provide an array of days (integers) to disable in the date picker
    const excluded_debit_days = _.get(this.fieldsets, 'payment.exclude_days', []);
    this.excluded_debit_days = excluded_debit_days;
    this.debitDateDisabled = (date, mode) => mode === 'day' && _.includes(excluded_debit_days, date.getDate());

    this.updateDebitDate = () => {
      let minimum = new Date(this.application.payment.join_date.getTime());

      const debit_date_minimum_offset = _.get(debit_date_minimum_offset_mapping, this.application.payment.frequency);
      if (debit_date_minimum_offset) {
        minimum.setDate(minimum.getDate() + debit_date_minimum_offset);
      }

      if (minimum < debit_date_min_value_from_today) {
        minimum = debit_date_min_value_from_today;
      }

      this.debit_date_minimum = minimum;
      let new_debit_date = minimum < this.application.payment.debit_date ? this.application.payment.debit_date : minimum;
      // While the new_debit_date is in the excluded days list, increment the day
      while(_.includes(excluded_debit_days, new_debit_date.getDate())) {
        new_debit_date.setDate(new_debit_date.getDate() + 1);
      }

      const debit_date_maximum_offset = _.get(debit_date_maximum_offset_mapping, this.application.payment.frequency);
      if (debit_date_maximum_offset) {
        let maximum = new Date(this.application.payment.join_date.getTime());
        maximum.setDate(maximum.getDate() + debit_date_maximum_offset);

        maximum = maximum || this.application.payment.debit_date; // When frequency is not yet selected
        this.debit_date_maximum = maximum;
        new_debit_date = maximum > new_debit_date ? new_debit_date : maximum;
        // While the new_debit_date is in the excluded days list, decrement the day (so that we don' go over the max)
        while(_.includes(excluded_debit_days, new_debit_date.getDate())) {
          new_debit_date.setDate(new_debit_date.getDate() - 1);
        }
      }

      this.application.payment.debit_date = new_debit_date;
    };

    const updateOperatorPaymentFrequency = (newFrequency) => {
      if (newFrequency !== undefined) {
        // Update the operator filter payment frequency to match the application
        OperatorService.filters.payment_frequency = comparatorUtilities.getPaymentFrequencyOptionFromKey(
            comparatorUtilities.getPaymentFrequencyKey(newFrequency)
        );
        updatePricing();
      }
    }

    $scope.$watch('ctrl.application.payment.frequency', (newVal) => {
      this.updateDebitDate();
      updateOperatorPaymentFrequency(newVal);
    });

    this.updateDebitDate();
    // End join and debit date configuration

    // If the current selected frequency is not available as an option, clear it
    const payment_freq = _.get(this.application, 'payment.frequency', null);
    const payment_freq_options = _.get(this.fieldsets, 'payment.frequency.choices', []).map(([val, _]) => val);
    if (payment_freq !== null && !payment_freq_options.includes(payment_freq)) {
      _.set(this.application, 'payment.frequency', undefined);
    }

    if (typeof this.application.payment === 'undefined') {
      this.application.payment = {
        frequency: 0,
        debit_day: 1,
        one_off: false
      };
    }

    // If only one option for payment type, default to that choice  
    if (_.get(this.fieldsets, 'payment.type.choices', []).length == 1) {
      this.application.payment.type = this.fieldsets.payment.type.choices[0][0];
    }

    // Update medicare details with info from primary applicant
    this.prepopulateField = (key) => {
      if (_.get(this.fieldsets, 'policy.medicare')) {
        if (_.isEmpty(_.get(this.application, `policy.medicare.${key}`))) {
          _.set(this.application, `policy.medicare.${key}`, _.get(this.application, `personal.${key}`));
        }
      }
      // Update partner and dependants last name, and payment account names
      if (key == 'last_name') {
        // Partner
        if (this.application.hasPartner() && _.isEmpty(_.get(this.application, 'partner.last_name'))) {
          _.set(this.application, 'partner.last_name', _.get(this.application, 'personal.last_name'));
        }
        // Dependants
        if (_.get(this.application, 'dependants', []).length) {
          for (let d of this.application.dependants) {
            if (_.isEmpty(_.get(d, 'last_name'))) {
              _.set(d, 'last_name', _.get(this.application, `personal.last_name`));
            }
          }
        }
        // Update account names
        const account_fields = [
          // [fieldset to check, field to update]
          ['payment.bank_account.account_name', 'payment.bank_account.account_name'],
          ['payment.credit_card.name', 'payment.credit_card.name'],
          ['payment.ezipay.account_name', 'payment.ezipay.account_name'],
          ['payment.bank_account.account_name', 'benefit_payment.bank_account.account_name'],
        ];
        for (let field of  account_fields) {
          if (_.get(this.fieldsets, field[0]) && _.isEmpty(_.get(this.application, field[1]))) {
            const first = _.get(this.application, 'personal.first_name', '');
            const last = _.get(this.application, 'personal.last_name', '');
            const name = first.length && last.length ? (first + ' ' + last) : (first || last);
            _.set(this.application, field[1], name);
          }
        }
      }
    };

    // If coming from Zoho, then a number of fields will already be populated
    for (let key of ['first_name', 'last_name', 'dob', 'gender']) {
      this.prepopulateField(key);
    }

    // Used to generate number of dependants drop down
    this.dependantsOptions = _.range(1, 20);

    // Allow child controllers to add functions to run before we submit. They should
    // return a promise; rejections will prevent submission from happening. Current
    // use case is BPoint integration where we need to tokenise credit card. Can
    // resolve to a function which can be used to transform the post data before it
    // is sent to the server. See usage below and AonApplicationService.submitApplication()
    // For example implementation look at step3-ctrl-hbf.js
    this.preSubmitFunctions = [];

    const rebatePageShowing = () => {
      const currentStateName = $state.current.name.split('.').slice(-1)[0];
      return currentStateName === 'rebate';
    };

    this.onSubmit = function(form, forceNoValidation=false) {

      // If we are not on the '.rebate' route, then let the backend know that
      // we are pending on the rebate script. The backenrd will tell us whether
      // we then need to show the rebate script or not.
      const pendingAGR = !rebatePageShowing();

      if (submissionCount > maxApplicationSubmissions) {
        this.debugTrace += '\nToo many submissions, aborting';
        this.debugTrace += '\n' + (new Error()).stack;
        $log.warn('Too many submissions, aborting');
        this.bailedOut = true;
        return;
      }

      this.debugTrace += `\nStep3 on submit, forceNoValidate: ${forceNoValidation}`;
      this.debugTrace += '\n' + (new Error()).stack;
      $log.warn('Step3 on submit, forceNoValidate:', forceNoValidation);

      // We hide the 'submit' button for preview anyway, but add a check here as well
      if (this.corporate.is_preview) return;

      // If response is an xml preview, store it here on the scope
      this.previewXML = null;

      // Save new value for rebate-related fields
      _.set(this.application, 'logging.submission.policy.lhc_age', this.application.policy.lhc_age);
      _.set(this.application, 'logging.submission.policy.lhc_age_partner', this.application.policy.lhc_age_partner);
      _.set(this.application, 'logging.submission.policy.federal_rebate', this.application.policy.federal_rebate);
      _.set(this.application, 'logging.submission.policy.rebate_tier', this.application.policy.rebate_tier);

      const onSuccess = (response) => {
        this.isLoading = false;
        console.log(_.get(response, 'show_rebate_script'))
        if (_.has(response, 'preview')) {
          this.previewXML = this.corporate.is_operator ? response.preview : 'This fund is in preview mode.';
        } else if (_.get(response, 'show_rebate_script')) {
          $state.transitionTo('comparator.step3.rebate');
        } else {
          $state.transitionTo('comparator.step4');
        }
      };

      /**
       * Map validation errors to fields in the form. If we only find errors that
       * we don't know how to map, return true to indicate a force resubmit is required.
       * @param errors
       * @returns {boolean} true if a forced resubmit (no validation) is required, else false
       */
      const handleErrors = (errors) => {
        let mappedErrors = 0; // number of errors we were ABLE to map to form fields
        let unmappedErrors = 0; // number of errors we were UNABLE to map to form fields

        if (_.isObject(errors)) {
          function recurse(root, path) {
            _.forEach(root, (val, key) => {
              if (Array.isArray(val)) {
                // Leaf

                // Dependants are handled specially, convert dependant.0 -> dependant0
                if (path[0] == 'dependant') {
                  path = [path.slice(0, 2).join('')];
                }

                // Radio buttons repeated across different forms are special, since
                // name needs to be unique for each button group, handle that here
                if (key == 'gender') {
                  const formObject = _.get(form, path.join('.'));
                  if (formObject) {
                    const possibleKeys = Object.keys(formObject).filter(k => k.split('-').slice(-1)[0] == 'gender');
                    if (possibleKeys.length) {
                      key = possibleKeys[0];
                    }
                  }
                }

                // The form structure is totally whack at this point - some form keys have periods
                // in them, so e.g. personal['application.number_of_dependants'] will work, but
                // personal.application.number_of_dependants won't. For now, we try grouping the last
                // two path components, in addition to trying the normal path access
                const fieldName = path.concat(key).join('.');
                const pathComponents = fieldName.split('.');

                // normal path access
                let field = _.get(form, fieldName);
                if (!field && pathComponents.length >= 2) {
                  // try with the last two path components grouped
                  const parentKey = pathComponents.slice(0, pathComponents.length - 2).join('.');
                  const fieldKey = pathComponents.slice(pathComponents.length - 2).join('.');
                  const parentObj = parentKey.length ? _.get(form, parentKey) : form;
                  if (parentObj) {
                    field = parentObj[fieldKey];
                  }
                }

                if (field) {
                  $log.error('Setting msg:', val, 'on', field);
                  field.setExternalValidation(null, val);
                  mappedErrors++;
                } else {
                  $log.error(`Cannot find form key ${fieldName} to set error '${val}'`);
                  unmappedErrors++;
                }
              } else if (typeof(val) === 'object') {
                recurse(val, path.concat(key));
              }
            });
          }

          try {
            recurse(errors, []);
          } catch(exception) {
            unmappedErrors++;
            $log.error(exception);
          }
        } else {
          unmappedErrors++;
        }

        if (mappedErrors === 0 && unmappedErrors > 0) {
          // The backend has told us there is an error in a form field that we don't know
          // about, so re-submit it and force no validation
          return true;
        } else if (mappedErrors > 0) {
          form.focusInvalid();
          return false;
        }
      };

      const onError = (result) => {
        this.debugTrace += `\nStep3 on error: ${JSON.stringify(result)}`;
        this.debugTrace += '\n' + (new Error()).stack;

        this.isLoading = false;
        const data = result.data;
        if (data.customer_reference) {
          // If we receive a reference back store it so next request uses same reference
          AonApplicationService.setCustomerReference(data.customer_reference);
        }
        if (result.status == 400) {
          // Normal validation errors - handle these, returns true if we need to force
          // a resubmit without validation
          const resubmitNoValidation = handleErrors(data.errors || {});
          if (resubmitNoValidation) {
            // We should never need to force a resubmit twice - enforce that here
            if (!forceNoValidation) {
              // First force resubmission, OK
              this.debugTrace += `\nStep3 forcing resubmit, forceNoValidation: ${forceNoValidation}`;
              this.onSubmit(form, true);
            } else {
              // We need to do _something_ - move to step 4
              $state.transitionTo('comparator.step4');
            }
          }
        } else {
          // Other errors - maybe internal, maybe gateway
          $state.transitionTo('comparator.step4');
        }
      };

      this.hasSubmitted = false;
      if (form.$valid) {
        this.isLoading = true;
        // Run any presubmit functions
        const preSubmitPromises =_.map(this.preSubmitFunctions, fn => fn(this.application));
        // Once all resolved...
        $q.all(preSubmitPromises).then(
          results => {
            // The results from preSubmitFunctions can be a data transform function which applies to the post data
            // we send to the server. This gives the opportunity for individual controllers to do things like
            // replace credit card details with a token etc.
            const transformFunctions = filter(results, isFunction);

            application['force_no_validate'] = forceNoValidation;
            application['pending_agr'] = pendingAGR;

            // Continue with submission if no rejections
            submissionCount++;
            this.debugTrace += `\nSubmission, app force no validate: ${application['force_no_validate'] = forceNoValidation}`;
            AonApplicationService.submitApplication(application, transformFunctions).then(onSuccess, onError);
          } ,
          errors => {
            this.isLoading = false;
            // Otherwise handle errors.
            onError({status: 400, data:{errors: errors}});
          }
        )
      } else {
        if (form.focusInvalid) {
          form.focusInvalid();
        }
        this.hasSubmitted = true;
      }
    };

    this.saveApplicationState = () => {
      this.isLoading = true;
      this.resultMessage = "";
      AonApplicationService.saveApplicationInZoho(application)
        .then((response) => {
          this.resultMessageClass = 'alert-success';
          return response;
        }, (response) => {
          this.resultMessageClass = 'alert-danger';
          return response;
        })
        .then((response) => {
          this.resultMessage = response.message;
          this.isLoading = false;
        });
    };


    this.updateDependants = (count) => {
      if (this.application.dependants.length > count) {
        this.application.dependants.splice(count);
      } else {
        const diff =  count - this.application.dependants.length;
        for (let i = 0;i < diff;i++) {
          this.application.dependants.push({});
        }
      }
      this.prepopulateField('last_name');
    };

    if (!application.requiresDependants()) {
      this.application.number_of_dependants = 0;
    }

    this.updateDependants(this.application.number_of_dependants);

    const getPaymentTypeLabel = () => this.fieldsets.payment.type.choices.filter(
        x => x[0] == this.application.payment.type)[0][1];

    // Watch for changes to payment type:
    // - if selecting credit card, pop up a warning in operator mode
    // - when changing Direct Debit, update price info and direct debit flag
    if (this.corporate.is_operator) {
      this.resume_recording_message_count = 0;
      $scope.$watch('ctrl.application.payment.type', () => {
        try {
          const payment_type_name = getPaymentTypeLabel();
          if (payment_type_name.search(/credit/i) !== -1
            && payment_type_name.search(/deferred/i) === -1)
          {
            this.operator_warning = "Please PAUSE CALL RECORDING while you get credit card details";
            $('#operator-warning').modal();
            this.resume_recording_message_count = 0;
          }

          const isBank = payment_type_name.search(/bank/i) !== -1;
          const hasDD = AonApplicationService.product.hasDirectDebitDiscount;
          AonApplicationService.product.apply_direct_debit_discount = isBank && hasDD;
          updatePricing();

        } catch (err) {
          $log.warn("Can't find payment type label, needed to warn operator about call recording during credit card details.")
        }
      });

      const resume_call = () => {
        this.operator_warning = "Please RESUME CALL RECORDING";
        $('#operator-warning').modal();
        this.resume_recording_message_count += 1;
      }

      $scope.$watch('ctrl.application.payment.credit_card.expiry', () => {
        if (_.has(this.application, 'payment.credit_card.expiry') &&
            this.resume_recording_message_count == 0 &&
            typeof this.application.payment.credit_card.expiry !== 'undefined') {
          resume_call();
        }
      });

      $scope.$watch('ctrl.application.payment.nab.crn', () => {
        if (_.has(this.application, 'payment.nab.crn') &&
            this.resume_recording_message_count == 0 &&
            this.application.payment.nab.crn.length > 0) {
          resume_call();
        }
      });

    }

    this.isFullTimeStudentAge = (dependant) => {
      try {
        const age = comparatorUtilities.calculateAge(dependant.dob);
        if (age >= this.fieldsets.dependant.full_time_student.minage &&
            age <= this.fieldsets.dependant.full_time_student.maxage ) {
          return true;
        } else {
          return false;
        }
      } catch(err) {
        console.log(err);
        return false;
      }
    };

    this.fieldsetValidClass = formKey => {
      const form = this.step3Form[formKey] || {};
      return {
        'fieldset-invalid': form.$invalid && this.hasSubmitted,
        'fieldset-valid': form.$valid,
      };
    };

    this.refetchPricing = () => {
      AonApi.fetchPrice(this.application, this.product.id).then(({ data: pkg }) => {
        const price = pkg.price;
        pkg.selectedPrice = price;
        AonApplicationService.setProduct(pkg);
        AonApplicationService.setPrice(price);
        AonApplicationService.saveApplication(this.application);
        this.product = AonApplicationService.product.selectedPrice;
        this.package = AonApplicationService.product;
        updatePricing();
      });
    }

    // If the rebate tier is changed, we need to re-fetch the price for updated pricing
    // information
    $scope.$watch('ctrl.application.policy.rebate_tier', this.refetchPricing);

    // If a discount code has been selected, and the code restricts the payment frequencies
    // allowed, then disable the frequency selection here
    $scope.$watch('ctrl.application.policy.discount_code', () => {
      restrictFieldSets(this.application, this.fieldsets);
    });

    // Start Rebate Scripting Page -----

    $scope.$watch(() => {
      return $state.$current.name;
    }, () => {
      // We use rebate_script in the backend to determine if the script has been completed.
      // Clear it on route change, to handle the case where operator clicks 'Yes', then
      // uses browser back button to go back to application, but does not go back to rebate
      // script page (maybe applicant changes their mind or something)
      _.set(this.application, 'rebate_script', {});
    });

    $scope.$watch('ctrl.application.policy.rebate_tier_confirmation', () => {
      // If the rebate tier is changed in the verbal rebate script, we need to show
      // a warning.
      const initial = _.get(this.application, 'policy.rebate_tier');
      const confirm = _.get(this.application, 'policy.rebate_tier_confirmation');
      _.set(this, 'verbal_rebate.errors.rebate_tier', initial !== confirm);
    });

    // Defualt the confirmed rebate tier to the selected rebate tier
    _.set(this.application, 'policy.rebate_tier_confirmation', _.get(this.application, 'policy.rebate_tier'));

    // Options for the rebate script
    const { validationType, rebateScript } = getRebateScriptConfig(AonConfig);
    this.rebateScript = rebateScript;
    this.rebateScriptMedicareColorOptions = rebateScriptMedicareColorOptions;
    this.getJoinDateFormatted = () => formatJoinDate(this.application);
    this.getDeclarationDateFormatted = () => formatDate(new Date());
    this.rebateScriptValid = () => isRebateScriptValid(this.application, validationType);
    this.getRebateTierIncome = () => getRebateTierIncome(this.application, AonApplicationService);

    // End Rebate Scripting Page -----

    // Sub-controllers should override this to provide custom logic for disabling the
    // next button
    this.applicationValid = () => rebatePageShowing() ? this.rebateScriptValid() : true;
  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl.js